import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '@common/components/form/inputs/text/text-input';
import BasePerformanceComponent from './base-performance-compoenent';

export type QuestionTextValue = string;

type QuestionTextProps = {
  item: any;
  value?: any;
  onChange?: (newValue: string) => void;
};

const PerformanceFormQuestionText = memo(({
  item,
  value = '',
  onChange
}: QuestionTextProps) => {
  const { t } = useTranslation();

  return (
    <BasePerformanceComponent item={item} fullClassName="Screen__Component__QuestionText">
      <TextInput
        value={value}
        disabled={!onChange}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={t('learning:component_type_question_text_placeholder')}
        className="tw-mt-4"
      />
    </BasePerformanceComponent>
  );

});

export default PerformanceFormQuestionText;
